import { SxProps, Theme } from "@/common/styles/style";

export const styles: { [key: string]: SxProps<Theme> } = {
  container: {
    height: "80vh",
  },
  title: {
    margin: "1rem 0",
  },
  dateArea: {
    marginBottom: "28px",
  },
  dataInput: {
    width: "220px",
    "& .MuiOutlinedInput-root": {
      height: "42px",
      borderRadius: "9px",
    },
    "& input": {
      fontSize: "16px",
    },
  },
  templateArea: {
    marginTop: "4px",
  },
  templateSelectWrapper: {
    width: "256px",
  },
  templateDate: {
    marginTop: "8px",
    marginLeft: "10px",
    marginBottom: "12px",
    color: "#999",
    fontSize: "14px",
  },
  templateError: {
    marginLeft: "10px",
    marginBottom: "20px",
  },
  errorText: {
    color: "#ff0000",
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: 1.8,
  },
  buttonArea: {
    width: "100%",
    justifyContent: "space-between",
  },
};